module.exports = __webpack_public_path__ + "../front/img/inventory-only-thumb.7248d272.jpg";